import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { WindowService } from '../window.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit {
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  
  windowsStarted: boolean = false;
  videoStarted: boolean = false;

  highestZIndex = 3;

  openWindows = [];

  currentTime: Date;

  constructor(private windowService: WindowService) {
    this.currentTime = new Date();
  }

  ngOnInit(): void {
    this.windowService.windows$.subscribe(updatedWindows => {
      this.openWindows = updatedWindows;  // Update the local array whenever the service array changes
    });
    setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  }

  ngAfterViewInit(): void {
    // this.videoPlayer.nativeElement.play();
  }

  // List of apps/icons that we have
  apps = [
    { name: 'About', title: 'About Anna Ladd', icon: '/assets/icons/Anna_About.PNG', component: 'about' },
    { name: 'Contact', title: 'Contact Anna Ladd', icon: '/assets/icons/Anna_Contact.PNG', component: 'contact' },
    { name: 'Projects', title: 'Anna Ladd\'s Projects', icon: '/assets/icons/Anna_Projects.PNG', component: 'projects' },
    { name: 'Minesweeper', title: 'Minesweeper', icon: '/assets/icons/Anna_MinesweeperBold.PNG', component: 'minesweeper' }
    // Add more apps/icons here
  ];

  // Method to open the window
  openWindow(app: string) {
    if (this.openWindows.findIndex(window => window.component === app) < 0) {
      for (let a of this.apps) {
        if (a.component == app) {
          this.openWindows.push(a);
        }
      }
      setTimeout(() => {
        const openedWindow = document.getElementById(app);
        let left = 0.4*(window.innerWidth - openedWindow.getBoundingClientRect().width);
        let top = 0.4*(window.innerHeight - openedWindow.getBoundingClientRect().height);
        if (window.innerWidth > 500) {
          if (app == 'about') {
            left = 150;
            top = 50;
            //  left = 0.08*window.innerWidth;
            //  top = 0.05*window.innerHeight;
          } else if (app == 'contact') {
            left = 150;
            top = 0.5*window.innerHeight;
          } else if (app == 'projects') {
            left = 0.32*window.innerWidth;
            top = 0.05*window.innerHeight;
          } else if (app == 'minesweeper') {
            left = window.innerWidth - openedWindow.getBoundingClientRect().width - 20;
            top = 0.05*window.innerHeight;
          }
        } else {
          if (app == 'about') {
            left = 20;
            top = 50;
          } else if (app == 'contact') {
            left = 20;
            top = 60;
          } else if (app == 'projects') {
            left = 20;
            top = 70;
          } else if (app == 'minesweeper') {
            left = 20;
            top = 80;
          }
        }
        
        
        openedWindow.style.left = `${left}px`;
        openedWindow.style.top = `${top}px`;
      }, 0.1);
    }
    setTimeout(() => {
      this.windowService.incrementHighestZIndex();
      const clickedWindow = document.getElementById(app);
      clickedWindow.style.zIndex = `${this.windowService.getHighestZIndex()}`;
    }, 0.1);
  }

  // Method to close the window
  closeWindow(app: string) {
    const index = this.openWindows.findIndex(window => window.component === app);
    if (index >= 0) {
      this.openWindows.splice(index, 1);
      this.windowService.updateWindows(this.openWindows);
    }
  }

  resetWindows() {
    this.windowsStarted = !this.windowsStarted;
    this.videoStarted = false;
    this.windowService.updateWindows([]);
    console.log(this.windowsStarted);
  }

  startVideo() {
    console.log("play");
    this.videoStarted = true;
    this.videoPlayer.nativeElement.play();
  }

}
